const FIRST_LETTER_PATTERN = /[a-zA-ZäöüÄÖÜß]/;

const capitalizeFirstLetter = (value: string): string => {
    if (value.length === 0) {
        return value;
    }

    const firstLetterMatch = value.match(FIRST_LETTER_PATTERN);

    if (!firstLetterMatch || firstLetterMatch.index === undefined) {
        return value;
    }

    const letterIndex = firstLetterMatch.index;

    return (
        value.slice(0, letterIndex) +
        value.charAt(letterIndex).toLocaleUpperCase('de-DE') +
        value.slice(letterIndex + 1)
    );
};

export const formatBackLinkLabel = (value: string): string => {
    const labelWithoutChevron = value.replace(/^\s*«\s*/, '');

    return `« ${capitalizeFirstLetter(labelWithoutChevron)}`;
};

export default capitalizeFirstLetter;
